const botFlow = {

  MAIN_MENU: {
  message: "Olá 👋 Seja bem-vindo! Como podemos te ajudar?",
  options: [
    { label: "🤖 Conhecer nossos Robôs", next: "ROBOT_TYPES" },
    { label: "👨‍💻 Suporte para o meu robô", next: "SUPORTE_MENU" },
    { label: "💵 Financeiro HLP", next: "FINANCEIRO_MENU" },
    { label: "💰 Valores e Orçamento", next: "VALORES_ORCAMENTO" },
    { label: "📞 Falar com Especialista", action: "OPEN_WHATSAPP" },
    { label: "❓ Outras dúvidas", next: "OUTRAS_DUVIDAS" },
  ],
},

  ROBOT_TYPES: {
    message: "Escolha o tipo de robô que deseja conhecer:",
    options: [
      { label: "🏢 Robô Entregador", next: "ROBO_ENTREGA" },
      { label: "🍴 Robô Garçom", next: "ROBO_REFEICAO" },
      { label: "🧽 Robô de Limpeza", next: "ROBO_LIMPEZA" },
      { label: "🚚 Robô de Logística", next: "ROBO_LOGISTICA" },
      { label: "❓ Outras Dúvidas", next: "OUTRAS_DUVIDAS" },
      { label: "🔙 Voltar ao menu inicial", next: "MAIN_MENU" },
    ],

  BUDGET_MENU: {
    message: "Qual robô deseja orçar?",
    options: [
      { label: "Robô Entregador", action: "SELECT_ROBOT", value: "Robô Entregador" },
      { label: "Robô Garçom", action: "SELECT_ROBOT", value: "Robô Garçom" },
      { label: "Robô de Limpeza", action: "SELECT_ROBOT", value: "Robô de Limpeza" },
      { label: "Robô de Logística", action: "SELECT_ROBOT", value: "Robô de Logística" },
      { label: "🔙 Voltar", next: "MAIN_MENU" },
    ],
  },
  },

  /* ============================= */
  /* 🔹 OUTRAS DÚVIDAS */
  /* ============================= */

  OUTRAS_DUVIDAS: {
    message: `A HLP é uma empresa especializada em soluções robóticas inteligentes, atuando desde a consultoria, implantação, integração até o suporte contínuo, ajudando empresas a automatizar processos, reduzir custos e aumentar eficiência operacional.`,
    options: [
      { label: "1️⃣ O robô funciona sozinho ou precisa de alguém operando?", next: "DUVIDA_AUTONOMIA" },
      { label: "2️⃣ Ele é seguro para ambientes com pessoas circulando?", next: "DUVIDA_SEGURANCA" },
      { label: "3️⃣ Preciso adaptar o ambiente para o robô funcionar?", next: "DUVIDA_ADAPTACAO" },
      { label: "4️⃣ Como funciona a manutenção do robô?", next: "DUVIDA_MANUTENCAO" },
      { label: "5️⃣ O robô gera relatórios ou dados de uso?", next: "DUVIDA_RELATORIOS" },
      { label: "6️⃣ 💬 Falar com um especialista", action: "OPEN_WHATSAPP_DUVIDAS" },
      { label: "🔙 Voltar ao menu anterior - Robôs", next: "ROBOT_TYPES" },
    ],
  },

DUVIDA_AUTONOMIA: {
  message: `1️⃣ O robô funciona sozinho ou precisa de alguém operando?

Sim ✅

Os robôs operam de forma totalmente autônoma, utilizando sensores avançados, mapeamento inteligente e navegação SLAM.

Não é necessário um operador dedicado.

--------------------------------------------------

Gostaria de saber mais sobre algum de nossos robôs?`,
  options: [
    { label: "1️⃣ Robô Entregador", next: "ROBO_ENTREGA" },
    { label: "3️⃣ Robô Garçom", next: "ROBO_REFEICAO" },
    { label: "2️⃣ Robô de Limpeza", next: "ROBO_LIMPEZA" },
    { label: "4️⃣ Robô de Logística", next: "ROBO_LOGISTICA" },
    { label: "💬 Falar com especialista", action: "OPEN_WHATSAPP" },
    { label: "🔙 Tenho outra dúvida", next: "OUTRAS_DUVIDAS" },
    { label: "🔙 Voltar ao menu inicial", next: "MAIN_MENU" },
  ],
},


DUVIDA_SEGURANCA: {
  message: `2️⃣ Ele é seguro para ambientes com pessoas circulando?

Sim ✅

Os robôs possuem sensores anti-colisão, câmeras e sistemas de detecção de obstáculos.

São totalmente seguros para ambientes com circulação de pessoas.

--------------------------------------------------

Gostaria de saber mais sobre algum de nossos robôs?`,
  options: [
    { label: "🔙 Tenho outra dúvida", next: "OUTRAS_DUVIDAS" },
    { label: "1️⃣ Robô Entregador", next: "ROBO_ENTREGA" },
    { label: "3️⃣ Robô Garçom", next: "ROBO_REFEICAO" },
    { label: "2️⃣ Robô de Limpeza", next: "ROBO_LIMPEZA" },
    { label: "4️⃣ Robô de Logística", next: "ROBO_LOGISTICA" },
    { label: "💬 Falar com especialista", action: "OPEN_WHATSAPP" },
    { label: "🔙 Voltar ao menu inicial", next: "MAIN_MENU" },
  ],
},


DUVIDA_ADAPTACAO: {
  message: `3️⃣ Preciso adaptar o ambiente para o robô funcionar?

Na maioria dos casos não ❌

Os robôs funcionam em ambientes já existentes.

Em alguns projetos pode ser recomendada pequena adaptação para melhor performance.

--------------------------------------------------

Gostaria de saber mais sobre algum de nossos robôs?`,
  options: [
    { label: "🔙 Tenho outra dúvida", next: "OUTRAS_DUVIDAS" },
    { label: "1️⃣ Robô Entregador", next: "ROBO_ENTREGA" },
    { label: "2️⃣ Robô de Limpeza", next: "ROBO_LIMPEZA" },
    { label: "3️⃣ Robô Garçom", next: "ROBO_REFEICAO" },
    { label: "4️⃣ Robô de Logística", next: "ROBO_LOGISTICA" },
    { label: "💬 Falar com especialista", action: "OPEN_WHATSAPP" },
    { label: "🔙 Voltar ao menu inicial", next: "MAIN_MENU" },
  ],
},


DUVIDA_MANUTENCAO: {
  message: `4️⃣ Como funciona a manutenção do robô?

A manutenção é simples e preventiva ✅

• Suporte técnico contínuo  
• Monitoramento remoto  
• Atualizações de software  
• Planos de manutenção programada  

--------------------------------------------------

Gostaria de saber mais sobre algum de nossos robôs?`,
  options: [
    { label: "🔙 Tenho outra dúvida", next: "OUTRAS_DUVIDAS" },
    { label: "1️⃣ Robô Entregador", next: "ROBO_ENTREGA" },
    { label: "2️⃣ Robô de Limpeza", next: "ROBO_LIMPEZA" },
    { label: "3️⃣ Robô Garçom", next: "ROBO_REFEICAO" },
    { label: "4️⃣ Robô de Logística", next: "ROBO_LOGISTICA" },
    { label: "💬 Falar com especialista", action: "OPEN_WHATSAPP" },
    { label: "🔙 Voltar ao menu inicial", next: "MAIN_MENU" },
  ],
},


DUVIDA_RELATORIOS: {
  message: `5️⃣ O robô gera relatórios ou dados de uso?

Sim ✅

Os robôs geram relatórios detalhados com:

• Rotas realizadas  
• Tempo de operação  
• Indicadores de performance  
• Histórico de entregas ou tarefas  

--------------------------------------------------

Gostaria de saber mais sobre algum de nossos robôs?`,
  options: [
    { label: "🔙 Tenho outra dúvida", next: "OUTRAS_DUVIDAS" },
    { label: "1️⃣ Robô Entregador", next: "ROBO_ENTREGA" },
    { label: "2️⃣ Robô de Limpeza", next: "ROBO_LIMPEZA" },
    { label: "3️⃣ Robô Garçom", next: "ROBO_REFEICAO" },
    { label: "4️⃣ Robô de Logística", next: "ROBO_LOGISTICA" },
    { label: "💬 Falar com especialista", action: "OPEN_WHATSAPP" },
    { label: "🔙 Voltar ao menu inicial", next: "MAIN_MENU" },
  ],
},



  /* ============================= */
  /* 🔹 ROBÔS */
  /* ============================= */

  ROBO_ENTREGA: {
    image: "roboEntrega",
    description: `Entregas autônomas e eficientes para ambientes internos.

💡 Principais Benefícios
• Redução de até 40% nos custos operacionais
• Entregas 24/7
• Navegação autônoma
• Integração com elevadores e catracas
• Dashboard em tempo real

🔗 https://hlp.vlink.dev.br/produto/entrega`,
    options: [
      { label: "💰 Solicitar orçamento", action: "SELECT_ROBOT", value: "Robô Entregador" },
      { label: "🔄 Ver outro robô", next: "ROBOT_TYPES" },
      { label: "❓ Outras Dúvidas", next: "OUTRAS_DUVIDAS" },
      { label: "🔙 Voltar ao menu inicial", next: "MAIN_MENU" },
    ],
  },

  ROBO_LIMPEZA: {
    image: "roboLimpeza",
    description: `Limpeza inteligente e automatizada.

💡 Benefícios
• Economia de até 60%
• Limpeza padronizada
• Mapeamento inteligente

🔗 https://hlp.vlink.dev.br/produto/limpeza`,
    options: [
      { label: "💰 Solicitar orçamento", action: "SELECT_ROBOT", value: "Robô de Limpeza" },
      { label: "🔄 Ver outro robô", next: "ROBOT_TYPES" },
      { label: "❓ Outras Dúvidas", next: "OUTRAS_DUVIDAS" },
      { label: "🔙 Voltar ao menu inicial", next: "MAIN_MENU" },
    ],
  },

  ROBO_REFEICAO: {
    image: "roboRefeicao",
    description: `Entregas confiáveis de refeições.

💡 Benefícios
• Redução do tempo de espera
• Operação contínua
• Controle térmico

🔗 https://hlp.vlink.dev.br/produto/refeicoes`,
    options: [
      { label: "💰 Solicitar orçamento", action: "SELECT_ROBOT", value: "Robô Garçom" },
      { label: "🔄 Ver outro robô", next: "ROBOT_TYPES" },
      { label: "❓ Outras Dúvidas", next: "OUTRAS_DUVIDAS" },
      { label: "🔙 Voltar ao menu inicial", next: "MAIN_MENU" },
    ],
  },

  ROBO_LOGISTICA: {
    image: "roboLogistica",
    description: `Movimentação automatizada de materiais.

💡 Benefícios
• +50% produtividade
• Integração com ERP
• Rotas inteligentes

🔗 https://hlp.vlink.dev.br/produto/logistica`,
    options: [
      { label: "💰 Solicitar orçamento", action: "SELECT_ROBOT", value: "Robô de Logística" },
      { label: "🔄 Ver outro robô", next: "ROBOT_TYPES" },
      { label: "❓ Outras Dúvidas", next: "OUTRAS_DUVIDAS" },
      { label: "🔙 Voltar ao menu inicial", next: "MAIN_MENU" },
    ],
  },

  POST_WHATS_OPTIONS: {
  message: "Escolha uma opção abaixo:",
  options: [
    { label: "🔄 Ver outro robô", next: "ROBOT_TYPES" },
    { label: "❓ Outras Dúvidas", next: "OUTRAS_DUVIDAS" },
    { label: "🔙 Voltar ao menu inicial", next: "MAIN_MENU" },
  ],
},

POST_WHATS_DUVIDAS: {
  message: "Posso te ajudar com mais alguma coisa?",
  options: [
    { label: "🤖 Conhecer nossos Robôs", next: "ROBOT_TYPES" },
    { label: "🔙 Voltar ao menu inicial", next: "MAIN_MENU" },
  ],
},

SUPORTE_MENU: {
  message: "",
  options: [],
},

POST_ORCAMENTO: {
  message: "O que você gostaria de fazer agora?",
  options: [
    { label: "🤖 Conhecer outros robôs", next: "ROBOT_TYPES" },
    { label: "❓ Outras dúvidas", next: "OUTRAS_DUVIDAS" },
    { label: "⬅ Voltar ao menu inicial", next: "MAIN_MENU" }
  ]
},

};

export default botFlow;
